import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import VerifySteps from "@/pages/home/components/VerifySteps";
import AddressEntries from "@/pages/home/components/AddressEntries";
import Troubleshoot from "@/pages/home/components/Troubleshoot";
import TopicWall from "@/pages/home/components/TopicWall";
import CoverPicks from "@/pages/home/components/CoverPicks";
import CommentWall from "@/pages/home/components/CommentWall";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <VerifySteps />
        <AddressEntries />
        <Troubleshoot />
        <TopicWall />
        <CoverPicks />
        <CommentWall />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}